import React, { useState } from 'react';
import './CheckboxList.css';

const CheckboxList = ({options, group, onChanger}) => {

  const [selectedId, setSelected] = useState(null);


  const handleToggle = (id) => {
	// If clicking the already selected one, uncheck it. Otherwise, select the new one.
	setSelected(prevId => (prevId === id ? null : id));
	
/*	console.log("selectedId");
	console.log(selectedId);
	console.log("id");
	console.log(id);    
	console.log("===");
	console.log(selectedId !== id);
	console.log(selectedId && selectedId !== id);
*/
	if (onChanger) {
	  onChanger(group, selectedId !== id ? id : '');
	}
  };

  return (
	<div className={"checkboxDiv"}>
	  {options.map((option) => (
	   
		  <label 
			className={
			  (selectedId && selectedId !== option) ? 'checkboxDisabled' : 'checkboxEnabled'
			}
		  > 
			<input
			  type="checkbox"
			  checked={selectedId === option}
			  onChange={() => handleToggle(option)}
			  // Disable if something else is already selected
			  disabled={selectedId !== null && selectedId !== option}
			/>
			&nbsp; {option}
		  </label>
		
	  ))}
	</div>
  );
};

export default CheckboxList;


// WEBPACK FOOTER //
// ./src/common/components/CheckboxList.jsx